import { useEffect } from 'react';

/**
 * Radix can leave its body-level pointer lock behind when an animated,
 * controlled dialog unmounts. Keep this guard app-local: it repairs only a
 * stale lock after every NavioFit dialog has gone, never while a modal is open.
 */
export function useDialogPointerLockGuard() {
  useEffect(() => {
    let frame: number | null = null;

    const scheduleRepair = () => {
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        frame = null;
        if (document.querySelector('[role="dialog"]')) return;
        if (document.body.style.pointerEvents === 'none') {
          document.body.style.removeProperty('pointer-events');
        }
      });
    };

    const observer = new MutationObserver(scheduleRepair);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    });
    scheduleRepair();

    return () => {
      observer.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, []);
}
